import React, { FC } from "react";
import { IFormItem, ISelectOption } from "../Types";
import { Form, Select } from "antd";

export const __FormSelect: FC<IFormItem> = (props) => {
    return (
        <Form.Item
            label={props.fieldLabel}
            name={props.fieldName}
            rules={props.rules}
            labelCol={props.labelCol}
            hidden={props.hidden}
        >
            <Select
                mode={props.selectMode}
                disabled={props.disable}
                allowClear={props.allowClear}
                showSearch={props.showSearch ?? true}
                optionFilterProp="label"
                options={props.ds}
                onChange={(value: string, option) => props.onSelectChange?.(value, option as ISelectOption)}
                onFocus={() => props.onSelectFocus?.()}
            />
        </Form.Item>
    )
}
